import React from 'react';
import classNames from 'classnames';
import ToolSortList from './ToolSortList/ToolSortList';
import SearchList from './SearchList/SearchList';
import ChartList from './ChartList/ChartList';
import { PopUp } from '@beisen/chaos-ui';
import SearchForm from '../Form/SearchForm';
import ToolItemLabel from './ToolItemLabel';
import transLoader from '@beisen/i18n-translation-loader';
require('./ToolsBar.scss');

const defaultTranslation = {
    chartList: '报表',
    searchList: '筛选',
    sortList: '排序'
};

const CHOOSE_CMP_TYPE = ['BC_CheckBoxList','BC_DropDownList','BC_RadioList'];
/*
    ToolsBar: 列表工具栏
*/

export default class ToolsBar extends React.Component {
	constructor(props) {
		super(props);
        this.reloadTable = this.reloadTable.bind(this);
        this.closePopUp = this.closePopUp.bind(this);
        this.blurHandler = this.blurHandler.bind(this);
        this.resetLookupFormData = this.resetLookupFormData.bind(this);
        this.handleClosePopAndCancel = this.handleClosePopAndCancel.bind(this);
        this.storeAdvanceLookupTempData = this.storeAdvanceLookupTempData.bind(this);
        this.state = {
            popShow: false
            ,leftWidth: 0
        };
        // this.popShow = false;
        this.getSearchData(props);
        this.sort_fields = props.tableData && props.tableData.sort_fields || [];
        //lookup高级搜索存放表单数据
        this.searchData = [];
        //记录初始化的搜索表单数据，用于重置功能
        this.initSearchData = this.props.searchData.items;
        this.fullPageCmps = ['BC_LookUp','BC_LookUpV2','BC_PopArea','BC_PopTree','BC_AutoComplete','BC_Staff','BC_UserSelect'];//点击搜索栏需要弹出全屏的组件
        this.touchItem = ''; // searchItem 代表快速筛选  searchList 代表全部筛选  ToolSortList 代表排序   ChartList 代表图表
        this.searchIndex = 999; // 0 代表搜索的第一项 1 代表搜索的第二项  3 代表排序  44  代表searchList或者ChartList  999 不代表任何事物
        this.translation = Object.assign({}, defaultTranslation, transLoader({
            chartList: 'toolsBar.chartList',
            searchList: 'toolsBar.searchList',
            sortList: 'toolsBar.sortList'
        }), props.translation);
    }

    componentDidMount() {
        this.getLeftWidth();
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.isLookupAdvanced) {
            this.initSearchData = nextProps.searchData.items;
        }
        if(this.props !== nextProps) {
            this.getSearchData(nextProps);
            this.getLeftWidth();
        }
    }

    getPopTop() {
        const toolsBar = this.refs.toolBar;
        const lookupNavHeight = this.props.getNavHeight && this.props.getNavHeight() || 0;
        const toolsBarHeight = toolsBar && toolsBar.offsetHeight || 0;
        const toolsBarTop = toolsBar && toolsBar.getBoundingClientRect().top || 0;
        return (this.props.isLookupAdvanced  ? lookupNavHeight : toolsBarTop) + toolsBarHeight;
    }

     // 筛选项过滤掉subcmps中隐藏的组件
     // 过滤掉部门多选的搜索
    getVisibleSubCmps(subCmps) {
        if(subCmps && subCmps.length > 0) {
            return subCmps.filter(item => {
                return item.cmp_data.cmp_status != 'invisible' && item.cmp_type !== 'BC_MultiDepartmentSearch';
            });
        }
        return [];
    }

    // 去除已经进行筛选的组件中隐藏的组件
    getVisibleBizData(searchData) {
        let visibleData = [];
        if(searchData.length > 0) {
            searchData.map(bizDataItem => {
                this.searchFormCmps.map(visibleItem => {
                    if(visibleItem.cmp_data.biz_data_key == bizDataItem.name) {
                        visibleData.push(bizDataItem);
                    }
                });
            });
        }

        return visibleData;
    }

    getSearchData(props) {
        const { searchData, searchFormData } = props;
        this.searchFormData = Object.assign({},searchFormData);
        this.searchFormCmps = this.getVisibleSubCmps(this.searchFormData.sub_cmps);

        this.hasSearchData = Object.assign([], searchData.items);
        this.hasSearchData = this.getVisibleBizData(this.hasSearchData);
    }

    getLeftWidth() {
        if(this.shouldShowSearchList() && this.props.chartData) {
            if(this.state.leftWidth !== 140) {
	            this.setState({ 'leftWidth': 140 });
	        }
        }else if(this.shouldShowSearchList() || this.props.chartData) {
            if(this.state.leftWidth !== 70) {
                this.setState({ 'leftWidth': 70 });
            }
        }else {
           if(this.state.leftWidth !== 0) {
               this.setState({ 'leftWidth': 0 });
            }
        }
    }

    // 有排序显示排序名称并高亮 没排序显示'排序'
    getSortLabel() {
        const { sortColumns, sortData } = this.props;
        // let label = this.props.translation.sortList;
        let label = this.translation.sortList;

        if(sortData && sortData.length > 0) {
            let hadSort = false;
            sortColumns.map(column => {
                if(column.sortField == sortData[0].sort_column && (this.sort_fields.length == 1 ? (this.sort_fields[0]['sort_name'] ? this.sort_fields[0]['sort_name'] == column.name : true) : true)) {
                    hadSort = true;
                    this.sortHighlight = true;
                    label = column.title;
                }
            });
            if(!hadSort) {
                this.sortHighlight = false;
            }
        }else {
            this.sortHighlight = false;
        }

        return label;
    }

    isOnlySort() {
        return this.searchFormCmps.length == 0 && this.props.sortColumns.length > 0;
    }

    isOnlyOneSearchItem() {
        return this.searchFormCmps.length == 1 && this.props.sortColumns.length == 0;
    }

    /*显示全部筛选的两种情况 1.有排序时 筛选条件大于一个 2.无排序时 筛选条件大于两个 */
    shouldShowSearchList() {
        return (this.props.sortColumns.length > 0 && this.searchFormCmps.length > 1) || (this.props.sortColumns.length == 0 && this.searchFormCmps.length > 2);
    }

    // 无筛选条件只有排序时  排序宽度 100%
    renderSortList() {
        const { sortColumns } = this.props;
        if(sortColumns && sortColumns.length > 0) {
            return (
                <div className={classNames('tool-item-container',{ 'tool-item-onlyOne': this.isOnlySort() })} onTouchStart={this.touchToolItem.bind(this,'ToolSortList',3)}>
                    <ToolItemLabel label={this.getSortLabel()}
                                   type="flex"
                                   highlight={this.sortHighlight}
                    />
                    {this.searchIndex == 3 && this.state.popShow ? <span className="trangle"><i /></span> : null}
                </div>
            );

        }
        return null;
    }

    // 有筛选项时  有值显示值 没值显示名称
    getSearchItemLabel(key) {
        this.searchItemHighlight = [];

        let label = this.searchFormCmps[key].cmp_data.title;

        let searchDataArr = Object.assign(this.hasSearchData, []);
        searchDataArr = searchDataArr.filter(item => {
            return item.text || item.value;
        });

        if(searchDataArr.length > 0) {
            this.searchListHighlight = true;
            const item = searchDataArr.find(item => this.searchFormCmps[key].cmp_data.biz_data_key == item.name);
            if(item) {
                this.searchItemHighlight[key] = true;
                label = item.text || '---';
            }
        }else {
            this.searchListHighlight = false;
            this.searchItemHighlight[key] = false;
        }
        return label;
    }

    // render  SearchItem  有就渲染  没有则返回空  无排序并且只有一个筛选条件时  宽度为100%
    renderSearchItem(key) {
        if(this.searchFormCmps.length > 0) {
            return (
                <div className={classNames('tool-item-container',{ 'tool-item-onlyOne': this.isOnlyOneSearchItem() })} onTouchTap={this.touchToolItem.bind(this,'searchItem',key)}>
                    <ToolItemLabel label={this.getSearchItemLabel(key)}
                                   type="flex"
                                   highlight={this.searchItemHighlight[key]}
                    />
                    {this.searchIndex == key && this.state.popShow ? <span className="trangle"><i /></span> : null}
                </div>
            );
        }
        return null;
    }

    // 此处渲染工具栏左侧第一个按钮 有排序时 为排序按钮  没有排序时 为全部筛选中的第一个
    renderLeftItem() {
        const { sortColumns } = this.props;
        if(sortColumns.length > 0) {
            return this.renderSortList();
        }
        return this.renderSearchItem(0);
    }

    // 此处渲染工具栏左侧第二个按钮 有排序时  渲染为全部筛选中的第一个 无排序时 渲染为全部筛选中的第二个
    renderRightItem() {
        const { sortColumns } = this.props;
        if(this.searchFormCmps.length > 0) {
            if((sortColumns.length == 0) && (this.searchFormCmps.length > 1)) {
                return this.renderSearchItem(1);
            }else if(sortColumns.length > 0 && this.searchFormCmps.length > 0) {
                return this.renderSearchItem(0);
            }
        }
        return null;
    }

    // 工具栏左侧 显示两个按钮 排序／筛选项 不定 LeftItem -> 第一个按钮  RightItem －>第二个按钮
    renderLeft() {
        return (
            <div className="tools-bar-left" style={{ width: 'calc(100% - ' + (this.state.leftWidth + 20) + 'px)' }}>
                {this.renderLeftItem()}
                {this.renderRightItem()}
            </div>
        );
    }

    // 工具栏右侧 显示全部筛选和报表按钮 此两项定宽 有显示没有就不显示
    renderRight() {
        // const { translation } = this.props;
        return (
            <div className="tools-bar-right" ref="barRight">
                {/*显示全部筛选的两种情况 1.有排序时 筛选条件大于一个 2.无排序时 筛选条件大于两个 */}
                {this.shouldShowSearchList() ?
                    <SearchList   ref='searchList'
                                  isLookupAdvanced={this.props.isLookupAdvanced}
                                  onBlur={this.blurHandler}
                                  searchFormData={this.props.searchFormData}
                                  reloadTable={this.props.reloadTable}
                                  actions={this.props.actions}
                                  popupPos={this.popupPos}
                                  pop_type='searchList'
                                  highlight={this.searchListHighlight}
                                  initSearchData={this.initSearchData}
                                  storeAdvanceLookupTempData={this.storeAdvanceLookupTempData}
                                  resetLookupFormData={this.resetLookupFormData}
                                  touchToolItem={this.closePopUp}
                                  translation={this.translation}
                                />
                    : null}
                {this.props.chartData ?
                    <ChartList {...this.props.chartData}
                               searchData={this.props.searchData}
                               tableData={this.props.tableData}
                               searchFormData={this.props.searchFormData}
                               NavView={this.props.NavView}
                               actions={this.props.actions}
                               chartData={this.props.chartData}
                               touchToolItem={this.closePopUp}
                               translation={this.translation}
                    /> : null
                }
            </div>
        );
    }

    touchToolItem(item,searchIndex,e) {
        e && e.preventDefault && e.preventDefault();
		e && e.stopPropagation && e.stopPropagation();
        if(!this.state.popShow) {
            if(item !== 'ChartList') {
                if(item !== 'SearchList') {
                    // 点击了筛选项或者排序
                    this.setState({ popShow: true });
                } else {
                    // 点击了全部筛选不需要隐藏头部和底部按钮
                }
                this.props.actions.serchonload(); // TODO 这个action也许可以不用发送了
            } else {
                // 点击了报表
            }
        } else {
            // 弹层处于显示状态
            if(item == 'searchItem') {
                if(this.props.isLookupAdvanced) {
                    // TODO
                    // 当前组件在高级lookup中
                } else {
                    // 当前组件在indexPage中  而不是在高级lookup中
                    // 并且点击了筛选项或者排序/或者切换弹层 相当于恢复默认搜索条件
                    this.props.actions.afterClearFn(this.props.searchFormData.cmp_id);
                }

                if(this.searchIndex == searchIndex) {
                    this.setState({ popShow: false });
                    // 设置延时只是为了等待动画执行完成
                    //this.delaySetState();
                } else {
                    // TODO
                }
            } else {
                // 点击了全部筛选或者是报表
                this.setState({ popShow: true });
                //this.delaySetState();
            }
        }
        if(this.searchIndex != searchIndex) {
            this.touchItem = item;
            this.searchIndex = searchIndex;
            this.forceUpdate();
        }
        // this.state.searchIndex != searchIndex  && this.setState({ touchItem: item, searchIndex: searchIndex });
    }

    // 延迟设置state
    // 设置延时只是为了等待动画执行完成
    // delaySetState() {
    //     setTimeout(() => {
    //         this.setState({ searchIndex: 999, touchItem: '' });
    //     }, 300);
    // }

    // 筛选项  点击遮罩 －>取消当次操作 关闭弹层  将点击项的key设置为999 点击项设置为空 去掉body上处理遮罩下内容模糊的class
    handleClosePopAndCancel() {
        if(this.touchItem == 'searchItem') {
            !this.props.isLookupAdvanced && this.props.actions.afterClearFn(this.props.searchFormData.cmp_id);
        }
        this.setState({ popShow: false },() => {
            this.touchItem = '';
            this.searchIndex = 999;
        });
    }


    //仅仅关闭弹层 不做数据操作
    closePopUp() {
        this.setState({ popShow: false });
    }
    /**
    * lookup高级搜索表单重置
    */
    resetLookupFormData() {
        this.searchData = this.initSearchData;
        this.props.resetLookupFormData && this.props.resetLookupFormData();
    }

    storeAdvanceLookupTempData(data) {
        this.props.storeAdvanceLookupTempData && this.props.storeAdvanceLookupTempData(data);
    }

    /**
    * lookup高级搜索，收集表单数据
    * value 是一个对象时是toosbar上单一项返回，是一个数组时是筛选表单提交后的数据
    */
    blurHandler(value) {
        const isArray = toString.call(value) === '[object Array]';
        if(isArray) {
            this.searchData = value;
        }else {
            if(this.searchData.length === 0) {
                this.searchData.push(value);
            }else {
                let canPush = true;
                this.searchData.forEach((data, index) => {
                    if(data.name === value.name) {
                        canPush = false;
                        this.searchData[index] = value;
                    }
                });
                canPush && this.searchData.push(value);
            }
        }

        //sortColumns决定当前视图是否有排序功能
        this.reloadTable(Object.assign({ searchData: this.searchData } , this.props.sortColumns.length > 0 ? { sortData: this.props.sortData } : {}));
    }

    reloadTable(tableParam,source) {
        this.sort_fields = tableParam.sortData;
        this.props.reloadTable(tableParam,source);
    }

    getSubCmps() {
        const { sub_cmps } = this.props.searchFormData;
        let subCmps = Object.assign(sub_cmps || [],[]);
        subCmps = this.getVisibleSubCmps(subCmps);
        return subCmps.length > 0 ? subCmps.slice(this.searchIndex,this.searchIndex + 1) : [];
    }

    isFullPageCmp(cmps = []) {
        const cmp = cmps[0];
        //let dataSourceLength = 0;
        // if(window.env.platform.android && cmp && CHOOSE_CMP_TYPE.includes(cmp.cmp_type)) {
        //     // 解决安卓中 弹层多次滚动部分白页
        //     const { cmp_data = {} } = this.props.searchFormData;
        //     const dataSource = cmp_data.datasource;
        //     if(dataSource && dataSource.length > 0) {
        //         const dataSourceResult = (dataSource.find(source => {
        //             return cmp.cmp_data.datasourcename === source.key;
        //         }) || {}).dataSourceResults;
        //         dataSourceLength = dataSourceResult ? dataSourceResult.length : 0;
        //     }
        // }
        //return (this.fullPageCmps.includes(cmp.cmp_type) || (dataSourceLength > 10));
        return this.fullPageCmps.includes(cmp.cmp_type);
    }

    // 渲染弹窗内容 分为两类 －> 排序，筛选项
    getPopContent() {
        // 如果点击的是搜索,则渲染Searchorm 如果点击的是排序则渲染ToolSortList
        if(this.touchItem == 'searchItem') {
            const { sub_cmps, ...other } = this.props.searchFormData;
            const subCmps = this.getSubCmps();
            return (
                <SearchForm {...other}
                            isLookupAdvanced={this.props.isLookupAdvanced}
                            onBlur={this.blurHandler}
                            sub_cmps={subCmps}
                            pop_type="searchItem"
                            actions={this.props.actions}
                            reloadTable={this.props.reloadTable}
                            handleCancel={this.handleClosePopAndCancel}
                            handleClosePopUp={this.closePopUp}
                            visible={this.state.popShow}
                />
            );
        }else if(this.touchItem == 'ToolSortList') {
            const { sortColumns } = this.props;
            return (<ToolSortList sortColumns={sortColumns}
                                  sortData={this.props.sortData}
                                  actions={this.props.actions}
                                  searchData={this.props.searchData}
                                  tableData={this.props.tableData}
                                  reloadTable={this.reloadTable}
                                  handleCancel={this.closePopUp}
                                  handleClosePopUp={this.closePopUp}
                />);
        }
    }

	render() {
        // ToolsBar -> SearchForm ->  Form -> SubComponent -> FormPart ->  SubComponent -> Field ->  各字段组件
        // 快速筛选 并且是全屏组件 直接渲染searchForm 由全屏组件自己渲染弹层
        // 全部筛选 SearchList组件自己维护弹层的渲染
        // 快速筛选 非全屏组件有ToolsBar组件自己维护弹层的渲染
        let { sub_cmps: toolBarArr = [] } = this.props.searchFormData;
        toolBarArr = this.getVisibleSubCmps(toolBarArr);

        const subCmps = this.getSubCmps();
        let popContent;
        if(subCmps.length != 0 && this.touchItem == 'searchItem' && this.isFullPageCmp(subCmps)) {
            popContent = this.getPopContent();
        }else {
            const top = this.getPopTop();
            popContent = (<PopUp ref='popup'
                                visible={this.state.popShow}
                                animation='topTool-slide-fade'
                                maskAnimation="fade"
                                onClose={this.handleClosePopAndCancel}
                                maskStyle={{ top: top }}
                                wrapStyle={{ top: top }}
                                style={{ background: '#fafafa' }}
                                wrapClassName={classNames('searchItem_wrap',{ 'bgOpacity': !this.state.popShow })}
                        >
                                {this.getPopContent()}
                        </PopUp>);
        }

        return (
            toolBarArr.length != 0 ? <div className="tools-bar border-1px" ref="toolBar">
                {this.renderLeft()}
                {this.renderRight()}
                <div className="clear" />
                {popContent}
            </div> : null
        );
	}
}



// WEBPACK FOOTER //
// ./src/components/ToolsBar/ToolsBar.js